import { render, staticRenderFns } from "./FilterBlock.vue?vue&type=template&id=01b3e668"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"
import style0 from "./FilterBlock.vue?vue&type=style&index=0&id=01b3e668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports